import React, {useEffect} from "react";
import {Button, Label, Menu, Pane, Table, TextInput, Tooltip} from "evergreen-ui";
import {
    getDatasourceIdNameMapping,
    getDatasourceOnTypeMapping,
    getDatasourceSection,
    getEntityIdNameMapping,
    getEntitySection,
    getIdNameMapping,
    getMeteocodeIdNameMapping,
    getPhotoRecorderIds,
    getStationSection,
    getSystemSection
} from "./Api";
import {useSelector} from "react-redux";
import SuspenseSpinner from "../../Utils/SuspenseSpinner";
import StationsFilterFullMonitoring from "./Selectors/StationFilterFullMonitoring";
import {filteredStationsFullSelectorMonitoring} from "./Filers/Station/selectorsMonitoring";
import SmartButton from "../Constructor/common/SmartButton";
import {filteredTypedSelector, stationsFilter5PropsSelector, stationsSetFilter5} from "../App/appSlice";
import dayjs from "dayjs";

export function Monitoring() {
    const [idNameMapping, setIdNameMapping] = React.useState('');
    const [datasourceIdNameMapping, setDatasourceIdNameMapping] = React.useState('');
    const [meteocodeIdNameMapping, setMeteocodeIdNameMapping] = React.useState('');
    const [entityIdNameMapping, setEntityIdNameMapping] = React.useState('');
    const [photos, setPhotos] = React.useState(new Set())
    const [startTime, setStartTime] = React.useState();
    const [endTime, setEndTime] = React.useState();
    let [systemSectionData, setSystemSectionData] = React.useState([]);
    let [systemSectionSummary, setSystemSectionSummary] = React.useState([]);
    let [indexes, setIndexes] = React.useState([]);
    let [dates, setDates] = React.useState([]);
    let [readyToCreateTable, setReadyToCreateTable] = React.useState(false);
    const [fetching, setFetching] = React.useState(false);
    let [pages, setPages] = React.useState([]);
    let [stationSection, setStationSection] = React.useState(new Map);
    let [datasourceSection, setDatasourceSection] = React.useState(new Map);
    let [shouldLoadMore, setShouldLoadMore] = React.useState(true);
    const [majorFetching, setMajorFetching] = React.useState(false)
    let [entitySection, setEntitySection] = React.useState(new Map)
    let [showSummary, setShowSummary] = React.useState(false);
    const [datasourceOnTypeMapping, setDatasourceOnTypeMapping] = React.useState();

    function getOnTypeMapping() {
        getDatasourceOnTypeMapping().then((res) => {
          setDatasourceOnTypeMapping(res.data)
        })
    }

    function getToday() {
        let date = new Date();
        let year = date.getFullYear()
        let month = parseInt(date.getMonth()) + 1
        let day = date.getDate()

        if (String(day).length === 1) {
            day = '0' + String(day)
        }

        if (String(month).length === 1) {
            month = '0' + String(month)
        }

        return year + '-' + month + '-' + day
    }

    const white = "#ffffff"
    const green = "#e1fce1"
    const yellow = "#faf7e1"
    const red = "#f7e3e1"
    const grey = "#DCDCDC"

    const filteredStations = useSelector(filteredStationsFullSelectorMonitoring);
    const datasourceTypesFilter = useSelector(filteredTypedSelector);

    function getStationMapping() {
        getIdNameMapping().then(response => {
            setIdNameMapping(response.data);
        })
    }

    function getDatasourceMapping() {
        getDatasourceIdNameMapping().then(response => {
            setDatasourceIdNameMapping(response.data);
        })
    }

    function getMeteocodeMapping() {
        getMeteocodeIdNameMapping().then(response => {
            setMeteocodeIdNameMapping(response.data);
        })
    }

    function getEntityMapping() {
        getEntityIdNameMapping().then(response => {
            setEntityIdNameMapping(response.data);
        })
    }

    function allPhotoRecorders() {
        getPhotoRecorderIds().then(response => {
            Object.entries(response.data).map(([key, photoId]) => {
                setPhotos(prev => new Set([...prev, photoId]))
            })
        })
    }

    function resetFields() {
        setIndexes([]);
        setDates([]);
        setReadyToCreateTable(false);
        setSystemSectionData([]);
        setSystemSectionSummary([]);
        setDates([]);
        setFetching(false);
        setPages([]);
        setStationSection(new Map);
        setDatasourceSection(new Map);
        setShouldLoadMore(true)
        setPhotos(new Set())
        setEntitySection(new Map)
        setShowSummary(false)
    }

    function onUpdate() {
        getOnTypeMapping()
        getStationMapping()
        getDatasourceMapping()
        getMeteocodeMapping()
        getEntityMapping()
        allPhotoRecorders()
        resetFields()
        let selectedIds = Object.entries(filteredStations)
            .map((station) => {
                return station['0']
            })
        if (selectedIds.length === 0) {
            return;
        }
        setMajorFetching(true)
        getSystemSection(startTime, endTime, 0, selectedIds).then(response => {
            let newData = [response.data['cellsByStationId']]
            setSystemSectionData(newData);

            let newSummary = [response.data['summaryCells']]
            setSystemSectionSummary(newSummary);
            setPages([0])
            let tmpIndexes = Object.entries(response.data['cellsByStationId'])
                .map(([key, value]) => {
                    return key
                })
            let indexesToAdd = [tmpIndexes]
            setIndexes(indexesToAdd);

            let tmpDates = Object.entries(response.data['cellsByStationId'][tmpIndexes[0]]['systemCellsByDate'])
                .map(([key, value]) => {
                    return key
                })
            tmpDates.sort((first, second) => {
                let splitFirst = first.split('-');
                let firstYear = splitFirst[0]
                let firstMonth = splitFirst[1]
                let firstDay = splitFirst[2]

                let splitSecond = second.split('-');
                let secondYear = splitSecond[0]
                let secondMonth = splitSecond[1]
                let secondDay = splitSecond[2]

                if (firstYear > secondYear) return 1
                if (firstYear < secondYear) return -1

                if (firstMonth > secondMonth) return 1
                if (firstMonth < secondMonth) return -1

                return firstDay - secondDay
            })
            setShowSummary(startTime === endTime);
            setDates(tmpDates);
        }).finally(() =>
            setMajorFetching(false)
        );
        setReadyToCreateTable(true)
    }

    function createStationSection(stationId) {
        getStationSection(startTime, endTime, stationId)
            .then(response => {
                if (stationSection.has(stationId)) {
                    stationSection.delete(stationId);
                } else {
                    stationSection.set(stationId, response.data);
                }
                setFetching(true);
            })
        setFetching(false)
    }

    function createDatasourceSection(datasourceId, stationId) {
        getDatasourceSection(startTime, endTime, stationId, datasourceId)
            .then((response) => {
                if (datasourceSection.has(datasourceId)) {
                    datasourceSection.delete(datasourceId)
                } else {
                    datasourceSection.set(datasourceId, response.data)
                }
                setFetching(true)
            })
        setFetching(false)
    }

    function getDatasourcesOfChosenType(chosenTypes) {
        if (chosenTypes === undefined || chosenTypes.length === 0) return []
        let requiredDatasources = []
        for (let dsType = 0; dsType < chosenTypes.length; dsType++) {
            let datasourceList = datasourceOnTypeMapping[chosenTypes[dsType]]
            if (datasourceList === undefined) continue
            for (let ds = 0; ds < datasourceList.length; ds ++) {
                requiredDatasources.push(datasourceList[ds]['id'])
            }
        }
        return requiredDatasources.map(el => el.toString())
    }

    function isDoUpdateDisabled() {
        return majorFetching
            || startTime === undefined
            || startTime === ''
            || endTime === undefined
            || endTime === ''
    }

    function createEntitySection(stationId, datasourceId, entityId) {
        getEntitySection(startTime, endTime, stationId, datasourceId, entityId)
            .then((response) => {
                if (entitySection.has(entityId)) {
                    entitySection.delete(entityId)
                } else {
                    entitySection.set(entityId, response.data)
                }
                setFetching(true)
            })
        setFetching(false)
    }

    useEffect(() => {
        if (fetching) {
            loadMoreData();
        }
    }, [fetching])

    useEffect(() => {
        document.getElementById('page').addEventListener('wheel', handleScroll);
        return function () {
            document.getElementById('page').removeEventListener('wheel', handleScroll)
        };
    }, []);

    useEffect(() => {}, [majorFetching])

    const handleScroll = (e) => {
        setFetching(true);
    };

    const loadMoreData = () => {
        if (indexes.length === 0) return
        let startId = parseInt(indexes[indexes.length - 1][indexes[indexes.length - 1].length - 1]) + 1;
        if (shouldLoadMore) {
            let selectedIds = Object.entries(filteredStations)
                .map((station) => {
                    if (station[1]['id'] === null || station[1]['id'] === undefined) {
                        return station[1]['station']['id']
                    }
                    return station[1]['id']
                })

            let tmpIndexes;
            let newIndexes;

            if (!isNaN(startId)) {
                getSystemSection(startTime, endTime, startId, selectedIds)
                    .then(response => {
                        let newId = parseInt(pages[pages.length - 1]) + 1;
                        let newData =  systemSectionData.concat(response.data['cellsByStationId']);
                        setSystemSectionData(newData);
                        let newSummary = systemSectionSummary.concat(response.data['summaryCells']);
                        setSystemSectionSummary(newSummary)
                        let newPages = [...pages, newId]
                        setPages(newPages)

                        tmpIndexes = Object.entries(response.data['cellsByStationId'])
                            .map(([key, value]) => {
                                return key
                            })

                        newIndexes = [...indexes, [tmpIndexes][0]];
                    }).catch(() => {
                    setShouldLoadMore(false)
                }).finally(() => {
                    setIndexes(newIndexes);
                    setReadyToCreateTable(true)
                    setFetching(false);
                })
            }
        }
        setReadyToCreateTable(true)
    };

    function getStationSectionTable(stationSection, stationId, dates) {
        let stationData = stationSection['cellsByDatasourceId'];
        let summary = stationSection['summaryCells']['summary'];
        let keys = Object.entries(stationData)
            .map(([key, value]) => {
                return key;
            })
        let requiredDatasources = getDatasourcesOfChosenType(datasourceTypesFilter);
        if (requiredDatasources.length !== 0) {
            keys = keys.filter(el => requiredDatasources.includes(el))
        }
        return keys.map((k) => (
            <>
                <tr>
                    <td width={"250px"} align={"center"}>
                        {photos.has(parseInt(k)) ?
                            <>
                                {datasourceIdNameMapping[k]}
                            </> :
                            <Menu.Item width='250px' height='100%' onClick = {() => createDatasourceSection(k, stationId)}>
                                {datasourceIdNameMapping[k]}
                            </Menu.Item>
                        }
                    </td>
                    <tr>
                        <table border={1}>
                            {Object.entries(stationData[k]).map(([dKey, dValue]) => (
                                dValue === null ?
                                <tr></tr> :
                                <tr>
                                    {dates.map((d) => (
                                        createCell(
                                            dValue['data'][d],
                                            countBreaks(
                                                datasourceIdNameMapping[k],
                                                Object.entries(stationData[k]).length
                                            )
                                        )
                                    ))}
                                    {showSummary ? <></> :
                                        createCell(
                                            summary[k][dKey],
                                            countBreaks(
                                                datasourceIdNameMapping[k],
                                                Object.entries(stationData[k]).length
                                            )
                                        )
                                    }
                                </tr>
                            ))}
                        </table>
                    </tr>
                </tr>
                {!datasourceSection.has(k) ? <></> :
                    getDatasourceSectionTable(k, dates, stationId)
                }
            </>
        ))
    }

    function getDatasourceSectionTable(datasourceId, dates, stationId) {
        let currentDatasourceSection = datasourceSection
            .get(datasourceId);
        let typical = currentDatasourceSection['cellsByMeteocodeCode']
        let seba = currentDatasourceSection['cellsByEntityId']
        let summary = currentDatasourceSection['summaryCells']['summary']
        if (typical !== undefined) {
            return <>
               {Object.entries(typical).map(([pKey, pValue]) => (
                    <>
                       <tr>
                           {parseInt(pValue['programIteratedNum']) === 0 ?
                               <td align={"center"} width={250}>
                                   {meteocodeIdNameMapping[pKey]}
                               </td> :
                               <td width={"250px"} align={"center"}>
                                   Программа №{pValue['programIteratedNum']}<br/>
                                   Раздел №{pValue['blockIteratedNum']}<br/>
                                   {meteocodeIdNameMapping[pKey]}
                               </td>
                           }
                           <tr>
                               {dates.map((d) => (
                                   createCell(pValue['cellsForMeteocode']['data'][d], 4)
                               ))}
                               {showSummary ? <></> :
                                   createCell(summary[pKey]['0'], 4)
                               }
                           </tr>
                       </tr>
                    </>
                ))}
            </>
        } else {
            return <>
                {Object.entries(seba).map(([sKey, sValue]) =>
                    <>
                        <tr>
                            <td width={"250px"} align={"center"}>
                                <Menu.Item width='250px' height='100%' onClick = {() => createEntitySection(stationId, datasourceId, sKey)}>
                                    {entityIdNameMapping[sKey]}
                                </Menu.Item>
                            </td>
                            <table border={1}>
                                {Object.entries(sValue).map(([lineKey, lineValue]) => (
                                    <tr width={"250px"}>
                                        {dates.map((d) => (
                                            createCell(
                                                lineValue['data'][d],
                                                countBreaks(
                                                    entityIdNameMapping[sKey],
                                                    Object.entries(sValue).length
                                                )
                                            )
                                        ))}
                                        {showSummary ? <></> :
                                            createCell(
                                                summary[sKey][lineKey],
                                                countBreaks(
                                                    entityIdNameMapping[sKey],
                                                    Object.entries(sValue).length
                                                )
                                            )
                                        }
                                    </tr>
                                ))}
                            </table>
                        </tr>
                            {entitySection.has(sKey) ?
                                getEntityTable(sKey, dates) :
                            <></>
                        }
                    </>
                )}
            </>
        }
    }

    function max(first, second) {
        return parseInt(first) > parseInt(second) ? first : second;
    }

    function countBreaks(keyName, rows) {
        return max(keyName.split(" ").length / ( 2 * rows), 1);
    }

    function getEntityTable(entityId, dates) {
        return <>
            {Object.entries(entitySection.get(entityId)['cellsByMeteocodeCode']).map(([eKey, eValue]) => (
            <tr>
                <td width={"250px"} align={"center"}>
                    {meteocodeIdNameMapping[eKey]}
                </td>
                <table border={1}>
                    <tr>
                        {dates.map((d) => (
                            createCell(eValue['data'][d], 4)
                        ))}
                        {showSummary ?
                            <></> :
                            createCell(entitySection.get(entityId)['summaryCells']['summary'][eKey]['0'], 4)
                        }
                    </tr>
                </table>
            </tr>
            ))}
        </>
    }

    function coverBreaks(num, word) {
        let amount = parseInt(num)
        return<>
            {[...Array(amount - 1)].map((i) => (
                <br/>
            ))}
            {word}
            {[...Array(amount)].map((i) => (
                <br/>
            ))}
        </>
    }

    function coverBreaksWithBoldCheck(num, actual, expected) {
        let amount = parseInt(num)
        let isBold = parseInt(actual) > parseInt(expected)
        return<>
            {[...Array(amount - 1)].map((i) => (
                <br/>
            ))}
            {isBold ? <>
                <b>{actual}</b>/{expected}
            </> :
                actual + '/' + expected
            }
            {[...Array(amount)].map((i) => (
                <br/>
            ))}
        </>
    }

    function checkBold(actual, expected) {
        let isBold = parseInt(actual) > parseInt(expected)
        return<>
            {isBold ? <>
                    <b>{actual}</b>/{expected}
                </> :
                actual + '/' + expected
            }
        </>
    }

    function createCell(monitoringBlock, breaks) {
        if (monitoringBlock === undefined) return <td width={"250px"}></td>
        let expected = monitoringBlock['expected'];
        let actual = monitoringBlock['actual'];
        let color = monitoringBlock['color'];
        if (color ==='WHITE' && expected === 0) return <td width={"250px"}></td>
        if (color ==='WHITE') return <td bgcolor={white} width={"250px"} align={"center"}>
            {coverBreaks(breaks, expected)}
        </td>
        if (color === 'RED') return <td bgcolor={red} width={"250px"} align={"center"}>
            {coverBreaks(breaks, expected)}
        </td>
        if (color === 'YELLOW') return <td bgcolor={yellow} width={"250px"} align={"center"}>
            {coverBreaksWithBoldCheck(breaks, actual, expected)}
        </td>
        if (color === 'GREEN') return <td bgcolor={green} width={"250px"} align={"center"}>
            {coverBreaksWithBoldCheck(breaks, actual, expected)}
        </td>
        return <td bgcolor={grey} width={"250px"} align={"center"}>
            {coverBreaks(breaks, actual)}
        </td>
    }

    function getSystemCell(page, stationId, date, color) {
        return systemSectionData[page][stationId]['systemCellsByDate'][date]['systemCellsCyColor'][color];
    }

    function legend() {
        return <Pane marginLeft={20} marginTop={20} width={1000}>
            <Table>
                <Table.Head border={true}>
                    <Table.Cell>
                    </Table.Cell>
                    <Table.Cell>
                    </Table.Cell>
                    <Table.Cell>
                        <h1>ЛЕГЕНДА</h1>
                    </Table.Cell>
                    <Table.Cell>
                    </Table.Cell>
                    <Table.Cell>
                    </Table.Cell>
                </Table.Head>
                <Table>
                    <Table.Row>
                        <Table.TextCell background={white}>
                            <Tooltip content={"Будущая дата. Информация " +
                                "о суммарном ожидаемом количестве данных всех программных метеокодов уровня, " +
                                "если соответствующая дата еще не наступила " +
                                "(в случае уровня метеокода данные показаны лишь по нему). " +
                                "Число источников отображается лишь на уровне системы!"}>
                                <Label>
                                    Будущая дата<br/>
                                    [Число источников]<br/>
                                    [Ожидание]<br/>
                                </Label>
                            </Tooltip>
                        </Table.TextCell>
                        <Table.TextCell background={green}>
                            <Tooltip content={"Информация о суммарных количествах ожидаемых и полученных (факт) данных " +
                                "всех программных метеокодов этого уровня, если по всем из них " +
                                "данных пришло не менее, чем ожидалось " +
                                "(в случае уровня метеокода данные показаны лишь по нему). " +
                                "Число источников отображается лишь на уровне системы!"}>
                                <Label>
                                    Данных достаточно<br/>
                                    [Число источников]<br/>
                                    [Факт / Ожидание]<br/>
                                </Label>
                            </Tooltip>
                        </Table.TextCell>
                        <Table.Cell background={yellow}>
                            <Tooltip content={"Информация о суммарных количествах ожидаемых и полученных (факт) данных " +
                                "всех программных метеокодов этого уровня, если по всем из них " +
                                "данные получены, но их меньше, чем ожидалось " +
                                "(в случае уровня метеокода данные показаны лишь по нему). " +
                                "Число источников отображается лишь на уровне системы!"}>
                                <Label>
                                    Данных недостаточно<br/>
                                    [Число источников]<br/>
                                    [Факт / Ожидание]<br/>
                                </Label>
                            </Tooltip>
                        </Table.Cell>
                        <Table.Cell background={red}>
                            <Tooltip content={"Информация о суммарном количестве ожидаемых данных " +
                                "всех программных метеокодов этого уровня, если ни по одному из них " +
                                "данные не были получены " +
                                "(в случае уровня метеокода данные показаны лишь по нему). " +
                                "Число источников отображается лишь на уровне системы!"}>
                                <Label>
                                    Данных нет<br/>
                                    [Число источников]<br/>
                                    [Ожидание]<br/>
                                </Label>
                            </Tooltip>
                        </Table.Cell>
                        <Table.Cell background={grey}>
                            <Tooltip content={"Информация о суммарном количестве полученных (факт) данных " +
                                "всех НЕпрограммных метеокодов этого уровня " +
                                "(в случае уровня метеокода данные показаны лишь по нему). " +
                                "Число источников отображается лишь на уровне системы!"}>
                                <Label>
                                    Без программы<br/>
                                    [Число источников]<br/>
                                    [Факт]<br/>
                                </Label>
                            </Tooltip>
                        </Table.Cell>
                    </Table.Row>
                </Table>
            </Table>
        </Pane>
    }

    function filters() {
        return <>
            <Pane marginLeft={20} display={"flex"} columnGap={10} marginBottom={15} marginTop={20} width={800}>
                <Pane>
                    <Pane width={300}>
                        <Label>Выберите начальную дату мониторинга</Label>
                    </Pane>
                    <Pane>
                        <TextInput
                            marginTop={10}
                            type = "date"
                            max={endTime !== undefined ? endTime : undefined}
                            min={endTime !== undefined ?
                                dayjs(endTime).subtract(1, "month").format('YYYY-MM-DD') :
                                undefined
                            }
                            value={startTime}
                            onChange={e => setStartTime(e.target.value)}
                        />
                    </Pane>
                </Pane>
                <Pane>
                    <Pane width={300}>
                        <Label>Выберите конечную дату мониторинга</Label>
                    </Pane>
                    <Pane>
                        <TextInput
                            marginTop={10}
                            type = "date"
                            min={startTime !== undefined ? startTime : undefined}
                            max={startTime !== undefined ?
                                dayjs(startTime).add(1, "month").format('YYYY-MM-DD') :
                                undefined
                            }
                            value={endTime}
                            onChange={e => setEndTime(e.target.value)}
                        />
                    </Pane>
                </Pane>
            </Pane>
            <Pane width={1000} marginLeft={10}>
                <StationsFilterFullMonitoring />
                <Pane marginLeft={10}>
                    <SmartButton
                        width={200}
                        buttonText={"Загрузить"}
                        display="flex" flexDirection="column" gap=".2rem"
                        isDisabled={isDoUpdateDisabled()}
                        disabledTooltip={"Выберите даты"}
                        onClickAction={() => onUpdate()}
                    />
                </Pane>
            </Pane>
        </>
    }

    function countTableWidth() {
        let sideColumnsAmount = dates.length > 1 ? 2 : 1
        let width = (dates.length + sideColumnsAmount) * 250
        return width + 'px'
    }

    function systemSectionTable() {
        return <>
            {majorFetching ? <SuspenseSpinner></SuspenseSpinner> :
                <Pane marginTop={20} marginLeft={15}>
                    {!readyToCreateTable ? <div></div> :
                        <table width={countTableWidth()} border={"1"}>
                            <table >
                                <tr>
                                    <td align={"center"} width={"250px"}>{"СТАНЦИЯ"}</td>
                                    {dates.map((t) => (
                                        <td align={"center"} width={"250px"}>{t}</td>
                                    ))}
                                    {showSummary ?
                                        <></> : <td align={"center"} width={"250px"}>{"∑"}</td>
                                    }
                                </tr>
                            </table>
                            <tbody>
                            {pages.map((p) => (
                                indexes[p] === undefined ? <></> :
                                    indexes[p].map((t) => (
                                        <table border={"1"}>
                                            <tr>
                                                <td width={"250px"} align={"center"} onClick={() => createStationSection(t)}>
                                                    <Button height={"220px"} width={"250px"}>
                                                        {idNameMapping[t]}
                                                    </Button>
                                                </td>
                                                <table border={"1"}>
                                                    <tr>
                                                        {dates.map((d) => (
                                                            getSystemCell(p, t, d, 'WHITE') === undefined ?
                                                                <td align={"center"} width={"250px"} bgcolor={green}>
                                                                    <big>
                                                                        <big>
                                                                            {getSystemCell(p, t, d, 'GREEN')['numOfDatasource']}<br/>
                                                                        </big>
                                                                    </big>
                                                                    {checkBold(getSystemCell(p, t, d, 'GREEN')['totalActual'],
                                                                        getSystemCell(p, t, d, 'GREEN')['totalExpected'])}
                                                                </td> :
                                                                <td align={"center"} width={"250px"} bgcolor={white}>
                                                                    <big>
                                                                        <big>
                                                                            {getSystemCell(p, t, d, 'WHITE')['numOfDatasource']}<br/>
                                                                        </big>
                                                                    </big>
                                                                    {getSystemCell(p, t, d, 'WHITE')['totalExpected']}
                                                                </td>
                                                        ))}
                                                        {showSummary ? <></> :
                                                            systemSectionSummary[p][t]['systemCellsCyColor']['WHITE'] === undefined ?
                                                                <td align={"center"} width={"250px"} bgcolor={green}>
                                                                    {checkBold(systemSectionSummary[p][t]['systemCellsCyColor']['GREEN']['totalActual'],
                                                                        systemSectionSummary[p][t]['systemCellsCyColor']['GREEN']['totalExpected'])}
                                                                </td> :
                                                                <td align={"center"} width={"250px"} bgcolor={white}>
                                                                    {systemSectionSummary[p][t]['systemCellsCyColor']['WHITE']['totalExpected']}
                                                                </td>

                                                        }

                                                    </tr>
                                                    <tr>
                                                        {dates.map((d) => (
                                                            getSystemCell(p, t, d, 'WHITE') === undefined ?
                                                                <td align={"center"} width={"250px"} bgcolor={yellow}>
                                                                    <big>
                                                                        <big>
                                                                            {getSystemCell(p, t, d, 'YELLOW')['numOfDatasource']}<br/>
                                                                        </big>
                                                                    </big>
                                                                    {checkBold(getSystemCell(p, t, d, 'YELLOW')['totalActual'],
                                                                        getSystemCell(p, t, d, 'YELLOW')['totalExpected'])}
                                                                </td> :
                                                                <td align={"center"} width={"250px"}></td>
                                                        ))}
                                                        {showSummary ? <></> :
                                                            systemSectionSummary[p][t]['systemCellsCyColor']['WHITE'] === undefined ?
                                                                <td align={"center"} width={"250px"} bgcolor={yellow}>
                                                                    {checkBold(systemSectionSummary[p][t]['systemCellsCyColor']['YELLOW']['totalActual'],
                                                                        systemSectionSummary[p][t]['systemCellsCyColor']['YELLOW']['totalExpected'])}
                                                                </td> :
                                                                <td align={"center"} width={"250px"}></td>
                                                        }

                                                    </tr>
                                                    <tr>
                                                        {dates.map((d) => (
                                                            getSystemCell(p, t, d, 'WHITE') === undefined ?
                                                                <td align={"center"} width={"250px"} bgcolor={red}>
                                                                    <big>
                                                                        <big>
                                                                            {getSystemCell(p, t, d, 'RED')['numOfDatasource']}<br/>
                                                                        </big>
                                                                    </big>
                                                                    {getSystemCell(p, t, d, 'RED')['totalExpected']}
                                                                </td> :
                                                                <td align={"center"} width={"250px"}></td>
                                                        ))}
                                                        {showSummary ? <></> :
                                                            systemSectionSummary[p][t]['systemCellsCyColor']['WHITE'] === undefined ?
                                                                <td align={"center"} width={"250px"} bgcolor={red}>
                                                                    {systemSectionSummary[p][t]['systemCellsCyColor']['RED']['totalExpected']}
                                                                </td> :
                                                                <td align={"center"} width={"250px"}></td>
                                                        }

                                                    </tr>
                                                    <tr>
                                                        {dates.map((d) => (
                                                            getSystemCell(p, t, d, 'WHITE') === undefined ?
                                                                <td align={"center"} width={"250px"} bgcolor={grey}>
                                                                    <big>
                                                                        <big>
                                                                            {getSystemCell(p, t, d, 'GREY')['numOfDatasource']}<br/>
                                                                        </big>
                                                                    </big>
                                                                    {getSystemCell(p, t, d, 'GREY')['totalActual']}
                                                                </td> :
                                                                <td align={"center"} width={"250px"}></td>
                                                        ))}
                                                        {showSummary ? <></> :
                                                            systemSectionSummary[p][t]['systemCellsCyColor']['WHITE'] === undefined ?
                                                                <td align={"center"} width={"250px"} bgcolor={grey}>
                                                                    {systemSectionSummary[p][t]['systemCellsCyColor']['GREY']['totalActual']}
                                                                </td> :
                                                                <td align={"center"} width={"250px"}></td>
                                                        }
                                                    </tr>
                                                </table>
                                            </tr>
                                            {!stationSection.has(t) ? <></> :
                                                getStationSectionTable(stationSection.get(t), t, dates)
                                            }
                                        </table>
                                    ))))}
                            </tbody>
                        </table>
                    }
                </Pane>
            }
        </>
    }

    return <div id={'page'}>
        <Pane>
            {filters()}
            {legend()}
            {systemSectionTable()}
        </Pane>
    </div>
}